import { toastError } from '@/services/toast';
import { Cities } from '@/types/cities';
import { Neighborhoods } from '@/types/neighborhoods';
import { City, Neighborhood, State } from '@gurupass/sdk';

import { apiClient } from '..';
import useLocationStore from '@/store/locationStore';
import { getGurupassClient } from '@/services/gurupass-api-client';

const locationStore = useLocationStore.getState();

type GetZipCodeResponse = {
	uf: string;
	localidade: string;
	bairro: string;
	logradouro: string;
};

// TODO: Migrar do viacep para a API propia do Gurupass
export async function getZipCode(zipCode: string): Promise<GetZipCodeResponse> {
	return new Promise((resolve, reject) => {
		apiClient()
			.get(`/api/zipcode/${zipCode}`)
			.then(response => {
				resolve(response.data);
			})
			.catch(error => {
				toastError('CEP não encontrado.');
				reject(error.response.data.message);
			});
	});
}

export async function getNeighborhoodsByCityId(
	cityId: string,
	forceRequest = false
): Promise<Neighborhood[] | undefined> {
	if (!forceRequest && locationStore.neighborhoods.cityId === cityId) {
		return locationStore.neighborhoods.data as any;
	}

	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.cities()
			.getNeighborhoods(cityId)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function createCity(city: {
	name: string;
	slug: string;
	state: { id: string };
}): Promise<City | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.cities().create(city).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function createNeighborhood(
	cityId: string,
	neighborhood: { name: string; slug: string }
): Promise<Neighborhood | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.cities()
			.createNeighborhood(cityId, neighborhood)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function activeNeighboorhoodService(
	neighborhoodID: string
): Promise<Neighborhood | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.cities()
			.activeNeighborhood(neighborhoodID)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function deactiveNeighboorhoodService(
	neighborhoodID: string
): Promise<Neighborhood | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.cities()
			.inactiveNeighborhood(neighborhoodID)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getCities(
	forceRequest = false
): Promise<City[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.cities().list().run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getStates(
	forceRequest = false
): Promise<State[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.states().getAll().run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getStateCities(id: string): Promise<City[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.cities().getByState(id).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}
